import { render, staticRenderFns } from "./IPencil.vue?vue&type=template&id=1923e654&"
import script from "./IPencil.vue?vue&type=script&lang=ts&"
export * from "./IPencil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports